import { TSchoolDocumentType } from "./state";

export const ROLE = {
  master: 1,
  creative: 2,
  normal: 3,
  light: 4,
  lowest: 5,
};

export const CLASSIFICATION = {
  high_school: "高校",
  junior_high_school: "中学",
  other_school: "その他",
};

export const APP = {
  dlp: "DLP",
  g4s: "GearForSchool",
  onemenu: "onemenu",
};

export const MIN_ENTRANCE_YEAR = 2018;

export const MAX_ENTRANCE_YEAR = new Date().getFullYear() + 1;

export const IMAGE_TYPE = {
  vertical: 1,
  horizontal: 2,
};

export const SCHOOL_DOCUMENT_TYPE = {
  delivery_and_invoice: "納品書 兼 請求書",
  invoice: "請求書",
  delivery: "納品書（教育）",
  shipping_delivery: "納品書（社内発送用）",
  receipt: "領収書",
};

export const SCHOOL_DOCUMENT_CATEGORY = {
  delivery_and_invoice: SCHOOL_DOCUMENT_TYPE.delivery_and_invoice,
  invoice: SCHOOL_DOCUMENT_TYPE.invoice,
  delivery: SCHOOL_DOCUMENT_TYPE.delivery,
  shipping_delivery: SCHOOL_DOCUMENT_TYPE.shipping_delivery,
  receipt: SCHOOL_DOCUMENT_TYPE.receipt,
};

// 学校側は納品書の用途（教育 / 社内発送用）を区別しないため、どちらも「納品書」1種別として見せる
export const MANAGER_SCHOOL_DOCUMENT_TYPE = {
  delivery_and_invoice: SCHOOL_DOCUMENT_TYPE.delivery_and_invoice,
  invoice: SCHOOL_DOCUMENT_TYPE.invoice,
  delivery: "納品書",
  shipping_delivery: "納品書",
  receipt: SCHOOL_DOCUMENT_TYPE.receipt,
};

export const MANAGER_SCHOOL_DOCUMENT_CATEGORY = {
  delivery_and_invoice: SCHOOL_DOCUMENT_TYPE.delivery_and_invoice,
  invoice: SCHOOL_DOCUMENT_TYPE.invoice,
  delivery: MANAGER_SCHOOL_DOCUMENT_TYPE.delivery,
  receipt: SCHOOL_DOCUMENT_TYPE.receipt,
};

export const DELIVERY_DOCUMENT_TYPES: TSchoolDocumentType[] = [
  "delivery",
  "shipping_delivery",
];

export const MATERIAL_FORMAT = {
  paper: "紙版",
  digital: "デジタル版",
};
